// src/pages/BlogDetail.jsx
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {supabase} from "../services/supabase";

export default function BlogDetail() {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            setLoading(true);
            const { data, error } = await supabase.from("blogs").select("*").eq("slug", slug).single();
            if (error) console.error(error);
            else setBlog(data);
            setLoading(false);
        };
        fetchBlog();
    }, [slug]);

    if (loading) return <div className="flex flex-col items-center justify-center h-screen text-gray-600">
        <svg
            className="animate-spin h-10 w-10 text-lime-600 mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            ></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
            ></path>
        </svg>
        <p className="text-lg font-semibold animate-pulse">Loading, please wait...</p>
    </div>;
    if (!blog) return <p className="text-center py-10">Blog not found.</p>;

    let parsedContent;

    try {
        const parsed = JSON.parse(blog.content);

        // Check that it's an array and has children arrays
        if (
            Array.isArray(parsed) &&
            parsed.every(
                block => block?.children && Array.isArray(block.children)
            )
        ) {
            parsedContent = parsed;
        } else {
            parsedContent = [
                { type: "paragraph", children: [{ text: blog.content }] },
            ];
        }
    } catch {
        parsedContent = [
            { type: "paragraph", children: [{ text: blog.content }] },
        ];
    }

    return (
        <main className="max-w-5xl mx-auto px-4 py-8">
    {/* ROW 1: Title + Image */}
    <section className="grid md:grid-cols-2 gap-6 items-center mb-10">
        <div>
            <h1 className="text-4xl font-extrabold text-gray-900 leading-tight mb-4">
                {blog.title}
            </h1>
            <div className="h-1 w-20 bg-indigo-600 rounded"></div>
        </div>

        <img
            loading="lazy"
            src={blog.thumbnail_url || "https://placehold.co/600x300"}
            alt={blog.title}
            className="w-full h-64 object-cover rounded-xl shadow-md"
        />
    </section>

    {/* ROW 2: Content */}
    <section className="bg-white rounded-xl shadow-sm p-6 md:p-10">
        <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
            {parsedContent.map((block, i) => (
                <p key={i}>
                    {block.children.map((child, j) => (
                        <span key={j}>{child.text}</span>
                    ))}
                </p>
            ))}
        </div>
    </section>
</main>

    );
}
